import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Grid from 'material-ui/Grid';
import colors from '../assets/colors.js'

const styles = theme => ({
	cardContainer: {
		display: 'flex',
		alignItems: 'stretch',
    textAlign: 'center',
    height: '100%',
	},
	card: {
		marginBottom: 15,
		padding: 40,
    background: 'white',
	},
  cardName: {
    color: colors.green,
    marginBottom: 0,
  },
  cardRole: {
    font: '300 16px/26px "Sans Source Pro", sans-serif',
    fontStyle: 'italic',
  },
  cardFoundation: { 
    font: '300 16px/26px "Sans Source Pro", sans-serif',
    fontStyle: 'italic',
    margin: '30px auto 20px',
    textTransform: 'uppercase',
  }
});

class Testimonial extends React.Component {

  render() {
  	const { classes, item } = this.props;

    return (
      <Grid container justify='center' alignItems='center' spacing={0} >
      	<Grid item xs={12} sm={10} className={classes.cardContainer}>
          <div className={classes.card}>
            <i class="material-icons">format_quote</i>
            <p>{item.content}</p>
            <h2 className={classes.cardName}>{item.name}</h2>
            <div className={classes.cardRole}>{item.role}</div>
            <div className={classes.cardFoundation}>{item.foundation}</div>
          </div>
        </Grid>
      </Grid>
    );
  }
}

Testimonial.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Testimonial);






// WEBPACK FOOTER //
// ./src/components/Testimonial.js